import MyAppointmentDetails from '../../components/user/MyAppointmentDetails';

const MyAppointmentsPage = () => {
    return(
        <MyAppointmentDetails/>
    )
}

export default MyAppointmentsPage;